"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var splitUrlPiece_1 = __importDefault(require("./splitUrlPiece"));
/**
 * Splits a URL in half by a `#`
 */
var splitHashParams = splitUrlPiece_1.default.bind(null, '#');
exports.default = splitHashParams;
